import { CaseTypeCustomFieldModel } from '../caseTypeCustomField/caseTypeCustomFieldModel';
import { CaseTypeReferenceLabelModel } from '../caseTypeReferenceLabel/caseTypeReferenceLabelModel';
import { CaseTypeModel } from './caseTypeModel';

export class CaseTypeEditModel extends CaseTypeModel {
    public caseTypeReferences: CaseTypeReferenceLabelModel[];
    public caseTypeCustomFields: CaseTypeCustomFieldModel[];
    public folderTemplateIds: number[];
    public caseFlagIds: number[];
    public documentTemplateIds: number[];
    public caseServiceIds: number[];
    public subjectTypeIds: number[];
    public caseReviewIds: number[];
    public defaultSubjectTypeId?: number;
}
